import { render, staticRenderFns } from "./form.producto.precio.venta.vue?vue&type=template&id=c04eb5e8&scoped=true&"
import script from "./form.producto.precio.venta.vue?vue&type=script&lang=js&"
export * from "./form.producto.precio.venta.vue?vue&type=script&lang=js&"
import style0 from "./form.producto.precio.venta.vue?vue&type=style&index=0&id=c04eb5e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04eb5e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
